import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import ArrowLink from "../../common/ArrowLink/ArrowLink";
import "./DashboardManagerHeader.scss";
import { UserRoleEnum } from "../../../helpers/enums";

const BoxSelfReading = (props) => {
  const { t } = props;
  return (
    <div className="card-1">
      <div className="content-info">
        <div className="inner-content-info">
          <div>
            <h2 className="title-text headline-bold-fs5 font-color-1">
              {t("dashboard.manager.self_read_card.title")}
            </h2>
            <p className="description-text paragraph-main-fs8 font-color-1">
              {t("dashboard.manager.self_read_card.description")}
            </p>
          </div>
          <div className="arrow-selector">
            <ArrowLink to={"/autolettura"} type="cta">
              {t("dashboard.impersonation.another_action.self_reading_new")}
            </ArrowLink>
          </div>
        </div>
      </div>
    </div>
  );
}; //UserRoleEnum.OPERATOR && UserRoleEnum.MANAGER
const BoxSelfReadingList = (props) => {
  const { t } = props;
  return (
    <div className="card-1">
      <div className="content-info">
        <div className="inner-content-info">
          <div>
            <h2 className="title-text headline-bold-fs5 font-color-1">
              {t("dashboard.manager.self_read_card.list_title")}
            </h2>
            <p className="description-text paragraph-main-fs8 font-color-1">
              {t("dashboard.manager.self_read_card.list_description")}
            </p>
          </div>
          <div className="arrow-selector">
            <ArrowLink to={"/lista-autoletture"} type="cta">
              {t("dashboard.impersonation.another_action.self_reading_list")}
              <span className="sr-only">{t("dashboard.manager.self_read_card.list.label")}</span> 
            </ArrowLink>
          </div>
        </div>
      </div>
    </div>
  );
}; //UserRoleEnum.OPERATOR && UserRoleEnum.MANAGER
const BoxUserOperatorCreate = (props) => {
  const { t } = props;
  return (
    <div className="card-1">
      <div className="content-info">
        <div className="inner-content-info">
          <div>
            <h2 className="title-text headline-bold-fs5 font-color-1">
              {t("dashboard.manager.card-two.new-user")}
            </h2>
            <p className="description-text paragraph-main-fs8 font-color-1">
              {t("dashboard.manager.card-two.new-user-description")}
            </p>
          </div>
          <div className="arrow-selector">
            <ArrowLink to={"/register-operators"} type="cta">
              {t("dashboard.manager.btn-create")}
            </ArrowLink>
          </div>
        </div>
      </div>
    </div>
  );
}; //userProfile.role === UserRoleEnum.MANAGER
const BoxUserMunicipalOperator = (props) => {
  const { t } = props;
  return (
    <div className="card-1">
      <div className="content-info">
        <div className="inner-content-info">
          <div>
            <h2 className="title-text headline-bold-fs5 font-color-1">
              {t("dashboard.manager.card-three.new-user")}
            </h2>
            <p className="description-text paragraph-main-fs8 font-color-1">
              {t("dashboard.manager.card-three.new-user-description")}
            </p>
          </div>
          <div className="arrow-selector">
            <ArrowLink
              to={{
                pathname: "/user-profile",
                params: { comunali: true },
              }}
              type="cta"
            >
              {t("dashboard.manager.btn-create")}
              <span className="sr-only">{t("dashboard.manager.card-three.new-user-municipal.label")}</span>
            </ArrowLink>
          </div>
        </div>
      </div>
    </div>
  );
}; //UserRoleEnum.MUNICIPAL_OPERATOR
const BoxContainerManager = (props) => {
  const { t } = props;
  return (
    <>
      <div className="manager-variant">
        <div className="manager-variant-card">
          <BoxUserOperatorCreate t={t} />
        </div>
        <div className="manager-variant-card">
          <BoxUserMunicipalOperator t={t} />
        </div>


        <div className="manager-variant-card">
          <BoxSelfReadingList t={t} />
        </div>
        <div className="manager-variant-card">
          <BoxSelfReading t={t} />
        </div>
      </div>
    </>
  );
};
const BoxContainerOperator = (props) => {
  const { t } = props;
  return (
    <>
      <div className="operator-variant">
        <div className="operator-variant-card">
          <BoxUserMunicipalOperator t={t} />
        </div>
        <div className="operator-variant-card">
          <BoxSelfReadingList t={t} />
        </div>
        <div className="operator-variant-card">
          <BoxSelfReading t={t} />
        </div>
      </div>
    </>
  );
};

const DashboardManagerHeader = (props) => {
  const { t } = useTranslation();
  const profileImage =
    useSelector((state) => state.auth.profile.profilePicture) || null;

  const getCards = () => {
    const cards = {
      [UserRoleEnum.MANAGER]: <BoxContainerManager t={t} />,
      [UserRoleEnum.OPERATOR]: <BoxContainerOperator t={t} />,
    };
    return cards[userProfile.role];
  };

  const userProfile = useSelector((state) => {
    return state.auth.profile;
  });
  const user = useSelector((state) => state.auth.user);

  const changeImage = () => {
    const acceptedRoles = [
      UserRoleEnum.MANAGER,
      UserRoleEnum.OPERATOR,
      UserRoleEnum.MUNICIPAL_OPERATOR,
    ];
    return userProfile && acceptedRoles.includes(userProfile.role) ? (
      <div className="change-image">
        <button
          className="gcap-cta"
          onClick={props.changeImage}
        >
          {t("user-profile.changeProfileImage")}
          <i className="gc-icon-functional-arrow-right" aria-hidden="true"></i>
        </button>
      </div>
    ) : null;
  };

  return (
    <div
      className="DashboardManagerHeader"
      data-testid="DashboardManagerHeader"
    >
      <div className="container">
        <div className="user-box-container">
          <div className="user-box">
            <div className="d-1 box manager-box">
              <div className="card-user">
                <div className="contact-card">
                  <div className="image-conture">
                    {profileImage ? (
                      <img src={profileImage} alt=""></img>
                    ) : (
                      <div className="avatar-placeholder">
                        <i
                          className="gc-icon-functional-profile-2-col"
                          aria-hidden="true"
                        >
                          <span className="path1"></span>
                        </i>
                      </div>
                    )}
                    <span />
                  </div>
                </div>

                <div className="contact-data">
                  <div className="inner-contact-container">
                    <div className="user-data-box">
                      <div className="greeting">{t("dashboard.greeting")},</div>
                      <div className="greeting-username headline-bold-fs3">
                        {userProfile.name} {userProfile.surname}
                      </div>
                    </div>
                    <p className="user-text paragraph-main-fs8">{user.username}</p>
                    <p className="user-role paragraph-small-fs9">
                      {t(`dashboard.manager.${user.role}`)}
                    </p>
                    {userProfile.role === UserRoleEnum.MUNICIPAL_OPERATOR ? (
                      <p className="user-role paragraph-small-fs9">{userProfile.operatorCity}</p>
                    ) : null}
                  </div>
                  <div className="container-change-image">{changeImage()}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {getCards()}
      </div>
    </div>
  );
};

DashboardManagerHeader.propTypes = {};

export default DashboardManagerHeader;
